<div *ngIf="loggedInUser">
  <bh-app-shell type="secondary" appname="Digital Dull Grading" [userfirstname]="loggedInUser.firstName"
    [userlastname]="loggedInUser.lastName" [useremail]="loggedInUser.email" logo="./assets/logo/bakerhughes.png"
    [navigationSelected]="navigationSelected" [navigation]="navItems"
    [settings]="settings"
    settingsSelected='[]'>
  </bh-app-shell>
</div>